/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DownloadItemRequestBuilderRequestsMetadata, type DownloadItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Invoice/Download
 */
export interface DownloadRequestBuilder extends BaseRequestBuilder<DownloadRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Invoice.Download.item collection
     * @param id Unique identifier of the item
     * @returns {DownloadItemRequestBuilder}
     */
     byId(id: number) : DownloadItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DownloadRequestBuilderUriTemplate = "{+baseurl}/Invoice/Download";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DownloadRequestBuilderNavigationMetadata: Record<Exclude<keyof DownloadRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: DownloadItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/* tslint:enable */
/* eslint-enable */
